/**
 * Check if the user has reduced motion enabled.
 *
 * @return {Boolean}
 */
export default () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
